import React from "react";
import {DatePicker, Form, message, Modal} from "antd";
import {ServiceUpdate} from "../../../../models/service";
import {Config} from "../../../../controller/Global";
import {HotSheetGet} from "../../../../models/hotsheet";

const FormItem = Form.Item;
const moment = require('moment');
const MANIFEST = Config.constant.service_type.manifest;

class WorkOrderDateUpdateForm extends React.Component {

  handleUpdateDate = () => {
    const {form, row} = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        Object.keys(values).forEach((key, index) => {
          const a = key.split('-');
          ServiceUpdate(a[1], {service_date: moment(values[key]).format('YYYY-MM-DD')})
            .then(response => {
              if (row.hotsheet_id) {
                HotSheetGet(row.hotsheet_id)
                  .then(hot_response => {
                    ServiceUpdate(hot_response.data.service.id, {'service_date': response.service_date})
                      // .then(ser_response => {
                      //   message.success('Service Date Updated in HotSheet successfully');
                      // })
                  });
              }
              message.success('Service Date Updated successfully');
              this.props.fetch();
            })
        });
      }
    });
    this.props.setModelVisible(false)
  };


  render() {
    const {row, visible} = this.props;
    const {getFieldDecorator} = this.props.form;
      return (
      <Modal title="Edit Date" width={500} centered visible={visible} onOk={this.handleUpdateDate} onCancel={() => this.props.setModelVisible(false)} okText="Update Date" destroyOnClose={true}>
        <div className={"edit-qty-modal edit-date"}>
          <Form>
            {row.service.map((service, index) => (
            <div key={index} className={"row"}>
              <div className="col-12">
                <h6>{service.type === MANIFEST? 'Manifest:': 'BOL:'} {service.manifest_number} </h6>
              </div>
               <div className="col-12 m-b-15">
                <h6>Date: </h6>
                  <FormItem>
                    {getFieldDecorator(`service_date-${service.id}`, {
                      initialValue: moment(service.service_date),
                      rules: [{required: true, message: 'Please select service date'}],
                    })(<DatePicker />)}
                  </FormItem>
                </div>
            </div>
          ))}
          </Form>
        </div>
      </Modal>
    )
  }
}

export const WorkOrderDateUpdate = Form.create()(WorkOrderDateUpdateForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/work_order/WorkOrderDateUpdate.jsx